"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSystemResponseT = exports.StatusSystemResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const status_message_js_1 = require("../../solarxr-protocol/rpc/status-message.js");
/**
 * Response containing all current valid statuses
 */
class StatusSystemResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStatusSystemResponse(bb, obj) {
        return (obj || new StatusSystemResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStatusSystemResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StatusSystemResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    currentStatuses(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new status_message_js_1.StatusMessage()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    currentStatusesLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startStatusSystemResponse(builder) {
        builder.startObject(1);
    }
    static addCurrentStatuses(builder, currentStatusesOffset) {
        builder.addFieldOffset(0, currentStatusesOffset, 0);
    }
    static createCurrentStatusesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startCurrentStatusesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endStatusSystemResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStatusSystemResponse(builder, currentStatusesOffset) {
        StatusSystemResponse.startStatusSystemResponse(builder);
        StatusSystemResponse.addCurrentStatuses(builder, currentStatusesOffset);
        return StatusSystemResponse.endStatusSystemResponse(builder);
    }
    unpack() {
        return new StatusSystemResponseT(this.bb.createObjList(this.currentStatuses.bind(this), this.currentStatusesLength()));
    }
    unpackTo(_o) {
        _o.currentStatuses = this.bb.createObjList(this.currentStatuses.bind(this), this.currentStatusesLength());
    }
}
exports.StatusSystemResponse = StatusSystemResponse;
class StatusSystemResponseT {
    constructor(currentStatuses = []) {
        this.currentStatuses = currentStatuses;
    }
    pack(builder) {
        const currentStatuses = StatusSystemResponse.createCurrentStatusesVector(builder, builder.createObjectOffsetList(this.currentStatuses));
        return StatusSystemResponse.createStatusSystemResponse(builder, currentStatuses);
    }
}
exports.StatusSystemResponseT = StatusSystemResponseT;
